/**************
 Global
 ***************/

// open models
function openModal(modal) {
    // open up modal
    modal.showModal();
    document.querySelector("body").classList.add("noScroll");
    // close on clicking outside of main container
    modal.addEventListener('click', function (e) {
        if (e.target === this) {
            this.close();
            document.querySelector("body").classList.remove("noScroll");
        }
    })
    // close on modal exit buttons
    modal.querySelectorAll('.closeModal').forEach(el => {
        el.addEventListener('click', function () {
            modal.close();
            document.querySelector("body").classList.remove("noScroll");
        })
    })
    // on close event remove noScroll on body
    modal.addEventListener('close', (event) => {
        document.querySelector("body").classList.remove("noScroll");
    })
}

// https://stackoverflow.com/a/46181
function validateEmail(email) {
    return String(email)
        .toLowerCase()
        .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
}

// get index of a specific element
function getElIndex(el) {
    let i;
    for (i = 0; el = el.previousElementSibling; i++) ;
    return i;
}

/*********
 FAQ
 *********/
document.querySelectorAll(".dropdown").forEach((dropdown) => {
    dropdown.addEventListener("click", function () {
        this.classList.toggle("active");
    });
});

/*********
 Simple Product Card
 *********/
document.querySelectorAll(`.simpleProductCardVariant`).forEach(el => {
    el.addEventListener('click', function () {
        // if active return to original image
        const card = this.closest('.simpleProductCard');
        const index = this.dataset.index;
        // handle dropdowns for extra color swatches
        if (this.classList.contains('overflow')) {
            card.querySelector('.simpleProductCardBlock').classList.toggle('active');
        }
        // return original image
        if (this.classList.contains('active')) {
            this.classList.remove('active');
            card.querySelector('.simpleProductCardImageVariantsItem.active')?.classList.remove('active');
            card.querySelector(`.simpleProductCardImageVariantsItem[data-index="0"]`).classList.add('active');
            return;
        }
        // swap image for variant image
        card.querySelector('.simpleProductCardVariant.active')?.classList.remove('active');
        this.classList.add('active');

        card.querySelector('.simpleProductCardImageVariantsItem.active')?.classList.remove('active');
        card.querySelector(`.simpleProductCardImageVariantsItem[data-index="${index}"]`).classList.add('active');
    })
})

/***************
 Suggestion Item
 ***************/

// toggle images and variant selector
document.querySelectorAll(`.sugItemVariant`)?.forEach(button => {
    button.addEventListener('click', function (e) {
        e.preventDefault();
        const parent = this.closest('.sugItem');
        if (this.classList.contains('active')) {
            parent.querySelectorAll('.sugItemImageVariant').forEach(img => {
                if (img.getAttribute('data-index') === '0') {
                    img.classList.add('active')
                } else {
                    img.classList.remove('active')
                }
            });
            parent.querySelectorAll('.sugItemVariant').forEach(item => item.classList.remove('active'));
            return;
        }
        parent.querySelectorAll('.sugItemVariant').forEach(item => item.classList.remove('active'));
        const index = this.getAttribute('data-index');
        const image = parent.querySelector(`.sugItemImageVariant[data-index="${index}"]`);
        this.classList.add('active');
        parent.querySelectorAll('.sugItemImageVariant').forEach(img => img.classList.remove('active'));
        image.classList.add('active');
    })
})

// toggle extra variant selectors
document.querySelectorAll('.sugItemVariantToggle')?.forEach(button => {
    button.addEventListener('click', function (e) {
        e.preventDefault();
        this.closest('.sugItemBlock').classList.toggle('active');
    })
})

// Add to cart
document.querySelectorAll('.sugItemATC')?.forEach(button => {
    button.addEventListener('click', async function (e) {
        e.preventDefault();

        // if product has more than one variant, open selector
        if (this.classList.contains('selector')) {
            openModal(this.closest('.sugItem').nextElementSibling);
            return;
        }

        // add loading animation
        this.classList.add("loading");

        // get formdata
        let formData = {
            items: [{
                quantity: 1,
                id: this.dataset.id,
            }]
        }

        // add product
        try {
            await addProduct(formData);
        } catch (e) {
            console.error(e);
        }

        // remove loading animation
        this.classList.remove("loading");

        // open cart
        await openCart();
    })
})

/* slide out selector */
document.querySelectorAll('.sugItemSelector')?.forEach(selector => {
    selector.querySelector('.sugItemSelectorBottomQuantity').addEventListener('click', function (e) {
        e.stopPropagation();
        e.preventDefault();
        let quantity = +this.querySelector('.sugItemSelectorBottomQuantityDisplay').textContent;
        if (e.target.classList.contains('sugItemSelectorBottomQuantityLess')) {
            if (quantity === 1) return;
            quantity--;
        } else if (e.target.classList.contains('sugItemSelectorBottomQuantityMore')) {
            quantity++;
        } else {
            return;
        }
        this.querySelector('.sugItemSelectorBottomQuantityDisplay').textContent = quantity.toString();
    })

    selector.querySelector('.sugItemSelectorBottomATC').addEventListener('click', async function (e) {
        e.preventDefault();

        // add loading animation
        this.classList.add("loading");

        // get selected variant
        let id = +this.closest('.sugItemSelector').querySelector('.sugItemSelectorVariantsItem input:checked').value;
        let quantity = +this.closest('.sugItemSelector').querySelector('.sugItemSelectorBottomQuantityDisplay').textContent;

        // get formdata
        let formData = {
            items: [{
                quantity: quantity,
                id: id,
            }]
        }

        // add product
        try {
            await addProduct(formData);
        } catch (e) {
            console.error(e);
        }

        // remove loading animation
        this.classList.remove("loading");

        // close the dialog
        this.closest('.sugItemSelector').close();

        // open cart
        await openCart();
    })
})

/**********
 side menu
 **********/
document.querySelectorAll(".openSideMenu").forEach((dropdown) => {
    dropdown.addEventListener("click", () => {
        dropdown.querySelector('.openSideMenuImgWrap').classList.toggle("active");
        dropdown.querySelector('.openSideMenuBottom').classList.toggle("active");
    });
});

/*************
 Wishlist
 *************/

// if logged in hit api, else remove from local storage
function removeFromWishlist(id, handle) {
    if (customerID) {
        // build data header
        const data = new URLSearchParams({
            store_id: Shopify.shop,
            customer_id: customerID,
            product_id: id
        });
        // request delete of item
        fetch('https://api.maltertech.com/wishlist/remove.php', {
            method: 'POST',
            body: data
        })
            .then(response => response.json())
            .then(response => console.log(response))
            .catch(error => console.error('Error:', error));
    } else {
        // retrieve wishlist and add handle to local storage
        const storageArray = localStorage.getItem("wishlist");
        // if there is a wishlist add, if not create
        const wishlist = storageArray ? JSON.parse(storageArray) : [];
        // remove handle from list
        let newWishList = wishlist.filter((wish) => wish.handle !== handle);
        // save new list to storage
        localStorage.setItem("wishlist", JSON.stringify(newWishList));
    }
}

// if logged in hit api, else add to local storage
function addToWishlist(id, handle) {
    if (customerID) {
        // build data
        const data = new URLSearchParams({
            store_id: Shopify.shop,
            customer_id: customerID,
            product_id: id
        });
        // send id to wishlist API
        fetch("https://api.maltertech.com/wishlist/add.php", {
            method: 'POST',
            body: data
        })
            .then(response => response.json())
            .then(data => console.log(data))
            .catch(error => console.error('Error:', error));
    } else {
        // retrieve wishlist and add handle to local storage
        const storageArray = localStorage.getItem("wishlist");
        // if there is a wishlist add, if not create
        const wishlist = storageArray ? JSON.parse(storageArray) : [];
        // make sure the item is not already in storage
        const itemExists = wishlist.some(item => item.id === id && item.handle === handle);
        // If the item doesn't exist, add it to the wishlist
        if (!itemExists) {
            wishlist.push({id, handle});
            localStorage.setItem("wishlist", JSON.stringify(wishlist));
        }
    }
}

// get wishlist
async function getWishList() {
    let wishlist = [];
    if (customerID) {
        // build data header
        const data = new URLSearchParams({
            store_id: Shopify.shop,
            customer_id: customerID,
            handles: true
        });
        // request wishlist
        await fetch('https://api.maltertech.com/wishlist/get.php', {
            method: 'POST',
            body: data
        })
            .then(response => response.json())
            .then(data => {
                // build wishlist array
                for (let item of data.wishlist) wishlist.push(item);
            })
            .catch(error => console.error('Error:', error));

    } else {
        // retrieve wishlist
        const storageArray = localStorage.getItem("wishlist");
        // if there is a wishlist add, if not create empty
        const temporaryWish = storageArray ? JSON.parse(storageArray) : [];
        for (let item of temporaryWish) {
            wishlist.push(item.handle);
        }
    }
    // return wishlist
    return wishlist;
}

/**********
 Product
 **********/

//add new product to cart
//let formData = { quantity: 1, id: 794864229, properties: { 'Personalize': 'ZHM' } };
function addProduct(formData) {
    return fetch('/cart/add.js', {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(function (data) {
            return data.json();
        })
}

//change an existing product in your cart
//let formData = { quantity: 1, id: 794864229 };
function changeProduct(formData) {
    return fetch('/cart/change.js', {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(function (data) {
            return data.json();
        })
}

//update cart note or attributes (_ for attributes are hidden and __ are private)
//let formData = { note: 'This is a note about my order', attributes: { 'Gift wrap': 'Yes' } }
function updateCart(formData) {
    return fetch('/cart/update.js', {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(function (data) {
            return data.json();
        })
}

//download product
function downloadProduct(handle) {
    return fetch(`/products/${handle}.js`)
        .then(function (data) {
            return data.json();
        })
        .then(function (data) {
            return data;
        })
        .catch((error) => {
            return false;
        });
}

// print price ($51.27 = 5127)
function price(amount, noZero = true) {
    let total = (parseFloat(amount) / 100).toFixed(2);
    if (noZero) {
        return `${currency}${total.replace(".00", "")}`;
    } else {
        return `${currency}${total}`;
    }
}

// sleep
function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}


// Function to send back in stock subscription to Klaviyo
async function sendKlaviyoBackInStockRequest(emailAddress, variantID) {
    await fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=${await klaviyo.account()}`, {
        method: 'POST',
        headers: {
            accept: 'application/vnd.api+json',
            revision: '2024-10-15',
            'content-type': 'application/vnd.api+json'
        },
        body: JSON.stringify({
            data: {
                type: "back-in-stock-subscription",
                attributes: {
                    channels: ["EMAIL"],
                    profile: {
                        data: {
                            type: "profile",
                            attributes: {
                                email: emailAddress,
                            }
                        }
                    }
                },
                relationships: {
                    variant: {
                        data: {
                            type: "catalog-variant",
                            id: `$shopify:::$default:::${variantID}`,
                        }
                    }
                }
            }
        })
    })
}